import { Injectable } from '@angular/core';
import { Events, Platform } from 'ionic-angular';
import { FirebaseApp } from '@angular/fire';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireAuth } from '@angular/fire/auth';
import { Storage } from '@ionic/storage';
import * as _ from 'lodash';
import { Firebase } from '@ionic-native/firebase';

@Injectable()
export class FirebaseServiceProvider {
  private messaging;
  private unsubscribeOnTokenRefresh = () => {};

  constructor(
    public events: Events,
    public db: AngularFireDatabase,
    private app: FirebaseApp,
    private storage: Storage,
    private firebase: Firebase,
    private platform: Platform,
    public afAuth: AngularFireAuth
  ) {
    // try {
    //   this.messaging = app.messaging();
    //   this.messaging.onMessage(function(payload) {
    //     console.log('Message received. ', payload);
    //   });
    //   navigator.serviceWorker
    //     .register('service-worker.js')
    //     .then(registration => {
    //       this.messaging.useServiceWorker(registration);
    //       this.enableNotifications();
    //     });
    // } catch (err) {
    //   console.log(err);
    // }
    afAuth.auth.signInAnonymously().then(
      () => {
        const query = db.list('events', ref =>
          ref.orderByChild('timestamp').startAt(Date.now())
        );

        query.valueChanges().subscribe(
          ref => {
            if (ref.length) {
              this.events.publish('timeline-changed', ref);
              if (_.last(ref).type === 'fulfillment') {
                this.events.publish('gift-added', _.last(ref));
              }
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      err => {
        console.log(err);
      }
    );
  }

  public processTimeline(timeline, event, newItems) {
    if (event.type === 'in') {
      this.addAskToTimeline(newItems, event.data);
    } else {
      this.removeAskToTimeline(timeline, event.data);
    }
  }

  private addAskToTimeline(timeline, ask) {
    timeline.unshift(ask);
  }

  private removeAskToTimeline(timeline, ask) {
    for (let i = timeline.length - 1; i >= 0; --i) {
      if (timeline[i].id == ask.id) {
        timeline.splice(i, 1);
      }
    }
  }

  public enableNotifications() {
    return this.messaging.requestPermission().then(() => {
      this.setupOnTokenRefresh();
      return this.updateToken();
    });
  }

  public disableNotifications() {
    this.unsubscribeOnTokenRefresh();
    this.unsubscribeOnTokenRefresh = () => {};
    return this.storage.set('fcmToken', '').then();
  }

  private updateToken() {
    return this.messaging.getToken().then(currentToken => {
      console.log(currentToken);
      if (currentToken) {
        return this.storage.set('fcmToken', currentToken);
      } else {
        console.log(
          'No Instance ID token available. Request permission to generate one.'
        );
      }
    });
  }

  private setupOnTokenRefresh(): void {
    this.unsubscribeOnTokenRefresh = this.messaging.onTokenRefresh(() => {
      this.storage.set('fcmToken', '').then(() => {
        this.updateToken();
      });
    });
  }

  onNotifications() {
    return this.firebase.onNotificationOpen();
  }

  async getToken() {
    let token;
    if (this.platform.is('android')) {
      token = await this.firebase.getToken();
    }
    if (this.platform.is('ios')) {
      await this.firebase.grantPermission(); // issue with ios when is on background
      token = await this.firebase.getToken();
      console.log('iOS device instance id : ', token);
    }
    this.storage.set('fcmToken', token);
  }
}



// WEBPACK FOOTER //
// ./src/providers/firebase-service/firebase-service.ts